import { usePaymentStore } from './payment';


import _ from "lodash";
import dayjs from "dayjs";
import { FIRESTORE_COLLECTIONS } from "~~/interface/FirestoreCollections";
import { setDoc, deleteDoc, onSnapshot, where, query, getDoc } from "firebase/firestore";
import { nanoid } from "nanoid";


//list generated qqrcode
export const useQrCodeStore = defineStore("qrcode", {
    state: () => {
        return {
            list: {} as any,
        };
    },
    getters: {
        getQrcode(state) {
            //get by table
            return (table) => {
                let result = _.filter(state.list, { table: table });
                result = _.orderBy(result, ["createdAt"], ["asc"])
                return result || []
            }
        },
        getQrcodeByQrcodeId(state) {
            //get by token
            return (token) => {
                let result = _.find(state.list, { qrcodeId: token });
                return result || null
            }
        },
        getEmployeeList(state) { 
            let empCode =  _.filter(state.list, { type : 'employee' }) || []
            let orderdItem = _.orderBy(empCode,['createdAt'], ['asc'])
            return orderdItem
        }
    },
    actions: {
        init() {
            this.fetch()
            this.subscribe()
        },
        subscribe() { 

            let payment = usePaymentStore()
            

            const unsubscribe = payment.$onAction(
                ({
                  name, // name of the action
                  store, // store instance, same as `someStore`
                  args, // array of parameters passed to the action
                  after, // hook after the action returns or resolves
                  onError, // hook if the action throws or rejects
                }) => {
                  
                  
                    if (name == 'submit') {
                        let t = store.table
                        this.removeByTable(t)
                    }

                    

                }
              )            
                            
        },
        async fetch() {

            let ref1 = useFirebaseFirestore().collectionRef(FIRESTORE_COLLECTIONS.QR_CODES)

            let q = query(ref1, where("storeId", "==", useFirebase().getStoreId()));
            onSnapshot(q, (querySnapshot) => {

                let res = {}
                querySnapshot.docs.forEach((doc) => {
                    let data = doc.data()
                    res[data.qrcodeId] = data
                });               
                
                this.list = res
            });        
        },

        async create(table, payload = {} as any) {
            const { qrcodeId, ref } = await this.getUniqueQrCodeId()
            const storeId = useFirebase().getStoreId()
            const createdAt = dayjs().format()
            const settingsStore = useSettingsStore()
            const defaultMenuSetting = settingsStore.qrMenuList?.[0]
            const selectedMenuSetting = payload?.settingId
              ? settingsStore.getBysettingId(payload.settingId, null)
              : defaultMenuSetting
        
            const data = {
                qrcodeId,
                storeId,
                createdAt,
                start_time: createdAt,
                hhmm: dayjs(createdAt).format('HH:mm'),
                length: 120,
                table,
                type: 'guest',
                hash: nanoid(6),
                settingId: selectedMenuSetting?.settingId || defaultMenuSetting?.settingId || "",
                settingName: payload?.settingName || selectedMenuSetting?.name || defaultMenuSetting?.name || "",
                footerText: selectedMenuSetting?.footerText || defaultMenuSetting?.footerText || "",
                ...payload
            }
        
            await setDoc(ref, data)
            this.list[qrcodeId] = data
            return data
        },
        async createEmployee (comment:string) {
            const { qrcodeId, ref } = await this.getUniqueQrCodeId()
            const storeId = useFirebase().getStoreId()

            const data = {
                qrcodeId,
                storeId,
                createdAt: dayjs().format(),
                type: 'employee',
                hash: nanoid(6),
                comment
            }

            await setDoc(ref, data)
            this.list[qrcodeId] = data

        },
        async update(qrcodeId, data) {       
            let ref1 = useFirebaseFirestore().collectionDocIdRef(FIRESTORE_COLLECTIONS.QR_CODES, qrcodeId)
            await setDoc(ref1, data)
            this.list[qrcodeId] = data
        },
     

        async remove(qrcodeId) {

            let ref1 = useFirebaseFirestore().collectionDocIdRef(FIRESTORE_COLLECTIONS.QR_CODES, qrcodeId)

            await deleteDoc(ref1)
        },


        async removeByTable(table) {

            let qrcodeList = this.getQrcode(table)

            for (let i = 0; i < qrcodeList.length; i++) {
                let qrcode = qrcodeList[i];
                await this.remove(qrcode.qrcodeId)
            }
        },

        async getUniqueQrCodeId(maxRetries = 5): Promise<{ qrcodeId: string, ref: any }> {
            const firestore = useFirebaseFirestore()
        
            for (let retries = 0; retries < maxRetries; retries++) {
                const qrcodeId = _.random(100000, 999999).toString()
                const ref = firestore.collectionDocIdRef(FIRESTORE_COLLECTIONS.QR_CODES, qrcodeId)
                const docSnap = await getDoc(ref)
        
                if (!docSnap.exists()) {
                    return { qrcodeId, ref }
                }
            }
        
            throw new Error('Failed to generate unique QR code ID after multiple attempts')
        }



    },
});
